import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import PhoneNumberDispositionBlockingAlert, {
  IPhoneNumberDispositionBlockingAlert
} from "../Components/Alerts/PhoneNumberDispositionBlockingAlert";

const id = "disposition_duplicateGuestsAlert";

const PhoneNumberDispositionBlockingAlertWithId: React.FC<
  Omit<IPhoneNumberDispositionBlockingAlert, "alertId">
> = props => PhoneNumberDispositionBlockingAlert({ ...props, alertId: id });

const SessionContextPhoneNumberDispositionBlockingAlert = SessionContextValueProvider({
  Component: PhoneNumberDispositionBlockingAlertWithId,
  map: ({ phoneNumberErrors }) => ({
    invalidPropNames: Object.entries(phoneNumberErrors)
      .filter(([, value]) => value)
      .map(([key]) => key)
  })
});

export default SessionContextPhoneNumberDispositionBlockingAlert;
